import { axiosClient } from '@services/clients'
import { serializeListParams } from './serializeListParams'

export async function getCampaigns(filters) {
  const { data } = await axiosClient(
    `/campaigns?${serializeListParams(filters)}`,
  )
  return data
}

export async function getCampaign(campaignId) {
  const { data } = await axiosClient(`/campaign/${campaignId}`)

  return data
}

export async function getCampaignEnabled(data, campaignId) {
  return axiosClient.patch(`/campaign/${campaignId}`, data)
}

export async function newCampaign(dataC) {
  const {
    data: { result },
  } = await axiosClient.post('/campaign', dataC)

  return result
}

export async function publishCampaign(campaignId) {
  const { data } = await axiosClient.post(`/campaign/${campaignId}/publish`, {})
  return data
}

export async function deleteCampaign(campaignId) {
  const { data } = await axiosClient.delete(`/campaign/${campaignId}`)
  return data
}

export async function updateCampaign(campaignId, payload) {
  const { data } = await axiosClient.patch(
    `/campaign/${campaignId}/fields`,
    payload,
  )
  return data
}
